import { queryOptions, useQuery } from "@tanstack/react-query";
import { api, type Me } from "~/core/api";
import { getQueryClient, keys, read } from "~/core/query";

/**
 * Who is signed in: the one read of it both modules make.
 *
 * The Agent used to ask on its own, of a route the server built from the same
 * row `/me` is built from, and kept the answer in a second cache entry that no
 * write of the panel's ever touched — one person, two answers, and a rename in
 * the account dialog that the Agent's account row did not see until a reload.
 *
 * Not `read`'s `staleTime: 0`. A screen mounting is no reason to ask who is
 * signed in again, and a score of Agent components read this. A minute, and
 * on focus: a session that expired while the tab sat in the background is
 * found the moment somebody comes back to it, and `SessionGate` turns that
 * 401 into the sign-in page.
 */
export const viewerQuery = queryOptions({
	queryKey: keys.me,
	queryFn: () => api.me(),
	...read,
	staleTime: 60_000,
	refetchOnWindowFocus: true,
});

export function useViewer() {
	return useQuery(viewerQuery);
}

/**
 * The viewer, for code outside React — the Agent's workflow operations stamp
 * their author with it. Whatever `SessionGate` last read, which it read before
 * anything that could ask was mounted.
 */
export function currentViewer(): Me | undefined {
	return getQueryClient().getQueryData(viewerQuery.queryKey);
}
